export const THEME_SWATCHES = 'color-picker-theme-color-swatches';
export const CUSTOM_SWATCHES = 'color-picker-custom-color-swatches';
export const PREDEFINED_SWATCHES = 'color-picker-predefined-color-swatches';
export const SWATCH = 'color-picker-color-swatch';
export const SWATCH_TOOLTIP = 'color-picker-colors-swatch-tooltip';
export const ADD_CUSTOM_COLOR_BUTTON = 'color-picker-add-custom-color-button';
export const FLOATING_COLOR_SWATCHES = 'color-picker-floating-color-swatches';
export const CUSTOM_COLOR_PICKER = 'color-picker-custom-color-picker';
export const RESET_BUTTON = 'color-picker-reset-button';
export const COLOR_PICKER_COLOR_SELECTED = 'color-picker-color-selected';
export const COLOR_PICKER_COLOR_ADDED = 'color-picker-color-added';
export const COLOR_PICKER_COLOR_PREVIEW = 'color-picker-color-preview';
